export const SET_FILE = 'SET_FILE'
export const RESET_FILE = 'RESET_FILE'
export const SET_ERROR_FILE = 'SET_ERROR_FILE'
export const RESET_ERROR_FILE = 'RESET_ERROR_FILE'
export const SET_TASK_FILE = 'SET_TASK_FILE'
export const RESET_TASK_FILE = 'RESET_TASK_FILE'
